import styled from "styled-components";
import bgLines from "assets/images/bg-lines.png";

export const PageTitle = styled.h1`
	font-weight: 700;
	font-size: 28px;
	line-height: 120%;
	letter-spacing: 0.2px;
	color: ${({theme}) => theme.color.tertiary};

	${({theme}) => theme.breakpoints.up("mobile")} {
		font-size: 32px;
		padding: 0 20px;
	}
`;

export const PageDesc = styled.h2`
	font-family: "Hind", sans-serif;
	font-weight: 700;
	font-size: 14px;
	line-height: 120%;
	letter-spacing: 0.02em;
	color: ${({theme}) => theme.color.tertiary};

	${({theme}) => theme.breakpoints.up("mobile")} {
		font-size: 16px;
		padding: 0 20px;
	}
`;

export const FormWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 40px;
	background: url(${bgLines}) no-repeat center 55px;
	background-size: 100%;
	padding: 0 20px;

	${({theme}) => theme.breakpoints.up("mobile")} {
		padding: 0;
		background-position-y: 120px;
	}
`;
